<template lang="html">
  <div class="h-100">
    <transition name="fade-from-top">
      <div v-if="open"
      class="options fixed absolute--fill h-100 w-100 overflow-y-hidden
      bg-white tl z-9999 db b--black
      absolute-ns absolute--clear-ns
      ba-ns br2-ns pa2-ns w-auto-ns h-auto-ns"
      >
        <slot>Dropdown controls not loaded</slot>
      </div>
    </transition>
    <div v-if="open" class="absolute--fill fixed z-999"
      @click="$emit('cancel')"
    />
  </div>
</template>

<script>
export default {
  props: {
    open: {
      type: Boolean,
      default: false
    },
  }
};
</script>

<style lang="scss" scoped>
.fade-from-top-enter-active, .fade-from-top-leave-active {
  transition: opacity .15s, transform .15s;
}
.fade-from-top-enter, .fade-from-top-leave-to /* .fade-leave-active below version 2.1.8 */ {
  transform: translateY(-10px);
  opacity: 0;
}

.options {
  min-width: 175px;
}
</style>



// WEBPACK FOOTER //
// src/components/DropdownContainer.vue